export function accessTokenKey(tokenObj) {
  return tokenObj.signingBundle.pass.token;
}
